module.exports = __webpack_public_path__ + "img/FQES01.7b577498.svg";